Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isPromise;
// to support Promise-like object.
function isPromise(value) {
    return value && typeof value.then === "function";
}


//////////////////
// WEBPACK FOOTER
// ../~/react-metrics/lib/core/utils/isPromise.js
// module id = 1553
// module chunks = 0